module.exports = __webpack_public_path__ + "static/media/dashboardTO.32511b18.jpg";